"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashAdapterName = exports.bigNumberToData = exports.addressToData = void 0;
var utils_1 = require("ethers/lib/utils");
var addressToData = function (address) { return address.replace("0x", "000000000000000000000000"); };
exports.addressToData = addressToData;
var bigNumberToData = function (number) { return number.toHexString().replace("0x", "").padStart(64, "0"); };
exports.bigNumberToData = bigNumberToData;
var hashAdapterName = function (name) { return (0, utils_1.keccak256)(new Buffer(name)); };
exports.hashAdapterName = hashAdapterName;
//# sourceMappingURL=adapterUtils.js.map